module.exports = __webpack_public_path__ + "img/Workshops, trainings & seminars.4ed90d61.svg";